import { SelectField } from "$components/rhf-fields";
import { gql, useQuery } from "@apollo/client";

interface RevenueDepartmentInputProps {
  name: string;
}

const QUERY = gql`
  query revenueDepartments {
    priceListV2 {
      revenueDepartments {
        edges {
          id
          name
        }
      }
    }
  }
`;

export const RevenueDepartmentSelectInput = ({
  name,
}: RevenueDepartmentInputProps) => {
  const { data: revDepts } = useQuery(QUERY);

  const revenueDepartmentsOptions =
    revDepts?.priceListV2.revenueDepartments.edges.map((revDep) => ({
      value: revDep.name,
      label: revDep.name,
    })) ?? [];

  return (
    <SelectField
      name={name}
      options={revenueDepartmentsOptions}
      required
      fullWidth
      hideHelper
    />
  );
};
